import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  usuarioLogado!: any;
  horaExpirarToken!: any;
  logado: boolean = false;
  private permissaoSubject = new BehaviorSubject<string[]>([]);
  permissao$ = this.permissaoSubject.asObservable();

  constructor() { }

    setPermissoes(permissoes: string[]) {
    localStorage.setItem('permissaoUsuario', JSON.stringify(permissoes));
    this.permissaoSubject.next(permissoes);
  }

  carregarPermissoes() {
    const perm = localStorage.getItem('permissaoUsuario');
    if (perm) {
      this.permissaoSubject.next(JSON.parse(perm));
    }
  }
}
